import React, { useEffect } from 'react'
import { Form, Row, Col, Container, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useStateValue } from '../../utilities/StateProvider';

export default function StepOne(props) {

    const [{ user }, dispatch] = useStateValue();

    useEffect(() => {
        const savedUser = JSON.parse(sessionStorage.getItem('user'));

        if (savedUser) {
            dispatch({
                type: 'setUser',
                user: savedUser
            });
        }

    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        
        const newUser = {
            ...user,
            name: form.name.value,
            lastname: form.lastname.value,
            birthdate: form.birthdate.value,
            email: form.email.value,
            phone: form.phone.value
        }

        sessionStorage.setItem('user', JSON.stringify(newUser));

        dispatch({
            type: 'setUser',
            user: newUser
        });

        props.next()

    }

    return (
        <Container>
            <Row>
                <Col className="step-header">
                    <div className="title">Datos Comprador</div>
                    <div className="subtitle">(Datos de quién realiza la compra)</div>
                </Col>
            </Row>
            <Form className="step-form" onSubmit={handleSubmit}>
                <Row>
                    <Col xs="12" md="4">
                        <Form.Control name="name" placeholder="Nombre" required defaultValue={user.name} />
                    </Col>
                    <Col xs="12" md="4">
                        <Form.Control name="lastname" placeholder="Apellido" required defaultValue={user.lastname}/>
                    </Col>
                    <Col xs="12" md="4">
                        <OverlayTrigger
                            trigger="hover"
                            placement="top"
                            delay={{ show: 100, hide: 250 }}
                            overlay={
                                props => (<Tooltip id="birthdate-tooltip" {...props}>Fecha de Nacimiento</Tooltip>)
                            }
                        >
                            <Form.Control name="birthdate" type="date" placeholder="Fecha de Nacimiento DD/MM/AAAA" required defaultValue={user.birthdate}/>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="6">
                        <Form.Control name="email" type="email" placeholder="Email" required defaultValue={user.email}/>
                    </Col>
                    <Col xs="12" md="6">
                        <Form.Control name="phone" placeholder="Teléfono" required defaultValue={user.phone}/>
                    </Col>
                </Row>
                <Button className="shop-button" onClick={props.prev}>Atrás</Button>
                <Button className="shop-button" type="submit">Siguiente</Button>
            </Form>
        </Container>
    )
}
